<template>
  <transition
    name="dialog-fade"
    @after-enter="afterEnter"
    @after-leave="afterLeave"
  >
    <div
      class="el-dialog__wrapper"
      v-show="visible"
      @click.self="handleWrapperClick"
    >
      <div
        role="dialog"
        aria-modal="true"
        :aria-label="title || 'dialog'"
         style="min-height:300px;min-width:400px;z-index:300;"
        :class="[
          fullscreen || isMax ? 'el-dialog' : 'el-dialog el-dialog2',
          { 'is-fullscreen': fullscreen || isMax, 'el-dialog--center': center },
          customClass,
        ]"
        ref="dialog"
        :style="style"
        
      >
        <div class="el-dialog__header" @dblclick="handleMax">
          <!--设置标题可指定属性title，也可以自定义标题<template slot="title"></template>-->
          <slot name="title">
            <span
              class="el-dialog__title"
              v-if="title != ''"
              style="font-size: 15px; font-weight: bold"
            >
              <i class="el-icon-setting" style="color: #409eff"></i>
              {{ title }}&nbsp;
            </span>
          </slot>
          <button
            type="button"
            class="el-dialog__headerbtn"
            aria-label="Close"
            v-if="showClose"
            style="top: 10px"
            title="关闭"
            @click="handleClose"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
          <button
            type="button"
            :style="showClose ? 'right:60px;' : 'right:20px;top:10px;'"
            class="el-dialog__headerbtn"
            aria-label="Close"
            v-if="false"
            title="最小化"
            @click="handlemin"
          >
            <i class="el-dialog__close el-icon el-icon-minus"></i>
          </button>
        </div>
        <div
          class="el-dialog__body"
          v-if="rendered"
          :style="footer ? 'padding: 10px 10px;flex:inherit;' : 'flex:inherit;'"
        >
          <slot></slot>
        </div>
        <!--页脚，如需要自定义页脚显示请使用<template slot="footer"></template>-->
        <div class="cus_footer el-dialog__footer" v-if="footer && cusfooter">
          <slot name="footer">
            <el-button size="mini" @click="handleClose">取消</el-button>
            <el-button size="mini" type="primary" @click="submit"
              >确定</el-button
            >
          </slot>
        </div>
      </div>
      <div
        v-if="visible"
        class="v-modal"
        :style="'z-index:' + zIndex + ';'"
      ></div>
    </div>
  </transition>
</template>

<script>
import Popup from "element-ui/lib/utils/popup";
import Migrating from "element-ui/lib/mixins/migrating";
import emitter from "element-ui/lib/mixins/emitter";
import mixin from "@/components/TagsView/mixin.js";
import theight from "@/components/TagsView/tableHeight.js";
export default {
  mixins: [mixin, theight],
  name: "ElDialog",

  mixins: [Popup, emitter, Migrating],

  props: {
    //最小宽度
    min_width: {
      type: Number,
      default: 400,
    },
    // Dialog 的标题，也可通过具名 slot （见下表）传入
    title: {
      type: String,
      default: "",
    },
    // modal    是否需要遮罩层(暂时不能设置)
    modal: {
      type: Boolean,
      default: false,
    },
    // 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上
    modalAppendToBody: {
      type: Boolean,
      default: false,
    },
    // 遮罩层是否插入至指定的元素上，默认为
    modalElId: {
      type: String,
      default: "",
    },
    // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
    appendToBody: {
      type: Boolean,
      default: false,
    },
    // lock-scroll    是否在 Dialog 出现时将 body 滚动锁定
    lockScroll: {
      type: Boolean,
      default: true,
    },
    // close-on-click-modal    是否可以通过点击 modal 关闭 Dialog
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    // close-on-press-escape    是否可以通过按下 ESC 关闭 Dialog
    closeOnPressEscape: {
      type: Boolean,
      default: false,
    },
    // show-close    是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true,
    },
    // show-min    是否显示最小化按钮
    showMin: {
      type: Boolean,
      default: true,
    },
    // show-max    是否双击最大化
    showMax: {
      type: Boolean,
      default: false,
    },
    // width    Dialog 的宽度
    width: {
      type: String,
      default: "50%",
    },
    // fullscreen    是否为全屏 Dialog
    fullscreen: {
      type: Boolean,
      default: false,
    },
    // custom-class    Dialog 的自定义类名
    customClass: {
      type: String,
      default: "",
    },
    // custom-style    Dialog 的自定义样式
    customStyle: {
      type: String,
      default: "",
    },
    // top    Dialog CSS 中的 margin-top 值
    top: {
      type: String,
      default: "15vh",
    },
    // before-close    关闭前的回调，会暂停 Dialog 的关闭
    beforeClose: Function,
    // center    是否对头部和底部采用居中布局
    center: {
      type: Boolean,
      default: false,
    },
    //footer    是否显示页脚
    footer: {
      type: Boolean,
      default: true,
    },
    //z-index   弹出框嵌套的层级，弹出框内嵌弹出框的时候需要设定大于默认值
    zIndex: {
      type: Number,
      default: 50,
    },
    //destroy-on-close    关闭时销毁 Dialog 中的元素
    destroyOnClose: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      closed: false,
      isMax: false,
      cusfooter: true,
    };
  },

  watch: {
    // 是否显示 Dialog，支持 .sync 修饰符
    visible(val) {
      if (val) {
        this.rendered = true;
        this.closed = false;
        this.$emit("open");
        this.$el.addEventListener("scroll", this.updatePopper);
        this.$nextTick(() => {
          this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        } else {
          let view = document.getElementById(this.modalElId);
          if (view) {
            view.appendChild(this.$el);
          }
        }
      } else {
        if (this.destroyOnClose) this.rendered = false;
        this.$el.removeEventListener("scroll", this.updatePopper);
        if (!this.closed) this.$emit("close");
      }
    },
  },

  computed: {
    style() {
      let style = {};
      if (this.customStyle != "") {
        let s = "marginTop:" + this.top + ";";
        s = s + this.customStyle;
        return s;
      }
      if (!this.fullscreen && !this.isMax) {
        if (this.cusfooter) {
          style.marginTop = this.top;
          if (this.width) {
            style.width = this.width;
          }
        }
      }
      return style;
    },
  },

  methods: {
    // 暂时没发现这个什么用
    getMigratingConfig() {
      return {
        props: {
          size: "size is removed.",
        },
      };
    },
    // 点击dialog自身
    handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    // 关闭dialog
    handleClose() {
      // 如果有beforeClose,执行beforeClose
      if (typeof this.beforeClose === "function") {
        this.beforeClose(this.hide);
      } else {
        // 否则隐藏
        this.hide();
      }
    },
    //最大化
    handleMax() {
      this.cusfooter = true;
      if (!this.showMax) return false;
      if (this.isMax) {
        this.isMax = false;
      } else {
        this.isMax = true;
      }
    },
    //最小化
    handlemin() {
      this.rendered = false;
      this.cusfooter = false;
    },
    // 隐藏dialog
    hide(cancel) {
      if (cancel !== false) {
        this.$emit("update:visible", false);
        this.$emit("close");
        this.closed = true;
        this.isMax = false;
      }
    },
    updatePopper() {
      this.broadcast("ElSelectDropdown", "updatePopper");
      this.broadcast("ElDropdownMenu", "updatePopper");
    },
    // Dialog 打开动画结束时的回调
    afterEnter() {
      this.$emit("opened");
    },
    // Dialog 关闭动画结束时的回调
    afterLeave() {
      this.$emit("closed");
    },
    submit() {
      this.$emit("submit");
    },
  },

  mounted() {
    if (this.visible) {
      this.rendered = true;
      this.cusfooter = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      } else {
        let view = document.getElementById(this.modalElId);
        if (view) {
          view.appendChild(this.$el);
        }
      }
    }
  },
  // 销毁前移除dom
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
};
</script>
<style lang="scss" scoped>
.el-dialog__title {
  font-size: 16px;
}
.el-dialog2 {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 200px);
  max-width: calc(100% - 30px);
}
.el-dialog2 .el-dialog__body,
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
  padding: 0 0 30px 0;
}
.cus_footer {
  height: 50px;
  /* margin: 0;
  padding: 0;
  position: absolute;
  bottom: 20px;
  right: 10px; */
}
.el-dialog__header {
  background: #f2f3f5;
  padding: 1px 10px;
  height: 34px;
  line-height: 34px;
}

.el-dialog__wrapper {
  position: static;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/dialogMsg.vue